module.exports = __webpack_public_path__ + "static/poster-da105b9d3a9c409f7df5e907e0f71aae.png";